import React, { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../store';
import { IChatSettingState } from '../store/chatSetting/types';
import ChatMessage from './ChatMessage';
import 'element-scroll-polyfill';
// import { IMessage } from '../store/chatmessage/types';
// import { AllProps } from '../containers/ChatMessageContainer';

interface IProps {
  setting: IChatSettingState;
}
const ChatMessageTree: React.FC<IProps> = props => {
  const messages = useSelector((state: AppState) => state.chatMessage);
  const [scrollPosition, setScrollPosition] = React.useState(0);

  useEffect(() => {
    const frameBody = document.querySelector('#chatbot-frame-body');
    if (frameBody != null) {
      frameBody.scroll({ top: scrollPosition, behavior: 'smooth' });
    }
  }, [scrollPosition]);

  const measureRef = useCallback(
    node => {
      if (node !== null && messages.length > 0) {
        setScrollPosition(node.scrollHeight);
      }
    },
    [messages]
  );

  useEffect(() => {
    localStorage.setItem('chat-message', JSON.stringify(messages));
  }, [messages]);

  if (messages.length === 0) {
    return <div />;
  }
  return (
    <React.Fragment>
      <div ref={measureRef}>
        {messages.map(message => (
          <ChatMessage
            key={message.message_id}
            setting={props.setting}
            data={message}
          />
        ))}
      </div>
    </React.Fragment>
  );
};

export default ChatMessageTree;
